import React from "react";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Password } from "primereact/password";
import AnttButton from "../../../vendors/components/Button";
import LoginFilter from "../../../vendors/pages/Auth/model/LoginFilter";
import ModalLoginInternoController from "./modal-login-interno.controller";
import "./index.scss";

interface Props {
  visible: boolean;
  onHide: () => void;
  dispositivoLogin: any;
  onLoginSuccess: (dispositivo: any) => void;
}

export default function ModalLoginInterno({
  visible,
  onHide,
  dispositivoLogin,
  onLoginSuccess,
}: Props) {
  const filterLogin = new LoginFilter();
  const controller = new ModalLoginInternoController(filterLogin);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    e.stopPropagation();
    controller.logar(dispositivoLogin, onLoginSuccess);
  };

  const dialogHeader = (
    <div className="modal-login-interno-header">
      <div className="modal-login-interno-header__icon" aria-hidden="true">
        <i className="pi pi-lock" />
      </div>
      <div className="modal-login-interno-header__text">
        <h2 id="modal-login-interno-title" className="modal-login-interno-header__title">
          Acesso interno
        </h2>
        <p className="modal-login-interno-header__subtitle">
          Utilize o login e a senha da rede corporativa ANTT
        </p>
      </div>
    </div>
  );

  return (
    <Dialog
      className="modal-login-interno-dialog"
      header={dialogHeader}
      visible={visible}
      draggable={false}
      onHide={() => onHide()}
    >
      <form
        className="modal-login-interno-form"
        onSubmit={handleSubmit}
        aria-labelledby="modal-login-interno-title"
      >
        <div className="modal-login-interno-form__fields">
          <div className="field">
            <label htmlFor="modal-login-interno-usuario">Nome de usuário</label>
            <InputText
              id="modal-login-interno-usuario"
              name="usuario"
              className="w-full"
              placeholder="Digite seu usuário de rede"
              autoComplete="username"
              value={filterLogin.usuario}
              onChange={(e) => filterLogin.setUsuario(e.target.value)}
            />
          </div>

          <div className="field">
            <label htmlFor="modal-login-interno-senha">Senha</label>
            <Password
              id="modal-login-interno-senha"
              name="senha"
              className="w-full"
              inputClassName="w-full"
              placeholder="Digite sua senha"
              feedback={false}
              toggleMask
              autoComplete="current-password"
              value={filterLogin.senha}
              onChange={(e) => filterLogin.setSenha(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && handleSubmit(e as any)}
            />
          </div>
        </div>

        <div className="modal-login-interno-form__actions">
          <AnttButton
            type="button"
            className="modal-login-interno-form__cancel"
            label="Cancelar"
            onClick={() => onHide()}
          />
          <AnttButton
            className="modal-login-interno-form__submit"
            type="submit"
            label="Fazer login"
            icon="pi pi-sign-in"
          />
        </div>
      </form>
    </Dialog>
  );
}
